// extracted by mini-css-extract-plugin
module.exports = {"root":"EventSummary_root__1wKbh","title":"EventSummary_title__2vi8u","row":"EventSummary_row__2zBUR","note":"EventSummary_note__3nTAv","divider":"EventSummary_divider__L0VZW"};